import type { Cart } from '@jane/bloom/types/schemas/bloom/checkout';
import { totalCount } from '@jane/bloom/utils/totalCount';

interface ProductCountInCartArgs {
  cart: Cart;
  currentStoreId?: number;
  productId?: number;
}

export const productCountInCart = ({
  cart,
  currentStoreId,
  productId,
}: ProductCountInCartArgs) => {
  return totalCount(
    cart.items.filter((cartItem) =>
      productId === undefined
        ? true
        : cartItem.productId === productId && currentStoreId === cart.storeId
    )
  );
};
